export default __webpack_public_path__ + "static/media/sort-arrow-down-default.06bdf75e.svg";